export default [
  {
    description: 'Default',
  },
  {
    description: 'Zweiter aktiv',
    active: 'substore.progress_summary',
  },
  {
    description: 'Dritter aktiv',
    active: 'substore.progress_confirmation',
  },
  {
    description: 'Vier',
    steps: [
      {
        name: 'substore.progress_selection',
      },
      {
        name: 'substore.progress_account',
      },
      {
        name: 'substore.progress_summary',
      },
      {
        name: 'substore.progress_confirmation',
      },
    ],
    active: 'substore.progress_selection',
  },
  {
    description: 'Vier: Zweiter Aktiv',
    steps: [
      {
        name: 'substore.progress_selection',
      },
      {
        name: 'substore.progress_account',
      },
      {
        name: 'substore.progress_summary',
      },
      {
        name: 'substore.progress_confirmation',
      },
    ],
    active: 'substore.progress_account',
  },
  {
    description: 'Vier: Dritter Aktiv',
    steps: [
      {
        name: 'substore.progress_selection',
      },
      {
        name: 'substore.progress_account',
      },
      {
        name: 'substore.progress_summary',
      },
      {
        name: 'substore.progress_confirmation',
      },
    ],
    active: 'substore.progress_summary',
  },
  {
    description: 'Vier: Vierter Aktiv',
    steps: [
      {
        name: 'substore.progress_selection',
      },
      {
        name: 'substore.progress_account',
      },
      {
        name: 'substore.progress_summary',
      },
      {
        name: 'substore.progress_confirmation',
      },
    ],
    active: 'substore.progress_confirmation',
  },
  {
    description: 'Optin test',
    steps: [
      {
        name: 'substore.progress_selection',
      },
      {
        name: 'substore.progress_account',
      },
      {
        name: 'substore.optin_progress_summary',
      },
      {
        name: 'substore.optin_progress_confirmation',
      },
    ],
    active: 'substore.optin_progress_summary',
  },
];
